const ROUTES = {
  verificationOfResidency: "/vor/:surveyHashId",
};

export default ROUTES;
